import type { PromotionInput } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import { get } from 'lodash';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { VayuTextField } from '../../../../../../../components/design/vayu-theme-components/VayuTextField';
import { PlanDurationSelect } from '../../../../../../../components/new-design/inputs/PlanDurationSelect';
import { useFormErrorNotificationContext } from '../../../../../../../contexts/form-error-notification-context/form-error-notification-context';
import { useChargeContext } from '../../../charge-context';
import type { PlanInputForm } from '../../../CreatePlanForm/create-plan-form-types/plan-input-form';
import type { CreatePlanTab } from '../../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { CREATE_PLAN_TABS } from '../../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { ChargeEditDrawerContentItemOptional } from '../../../FixedChargeEditDrawer/fixed-charge-edit-drawer-components/ChargeEditDrawerContentItemOptional';

export const PercentageChargeEditDrawerContent: React.FC = () => {
  const { itemIndex: promotionIndex } = useChargeContext<PromotionInput>();
  const { registerErrorField } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();
  const { control, setValue, register, formState: { errors } } = useFormContext<PlanInputForm>();

  const registerDescription = register(`promotions.${promotionIndex}.description`);
  const registerRecurringAmount = register(`promotions.${promotionIndex}.promotionModel.promotionConfiguration.recurringAmount`);

  registerErrorField(registerDescription.name, CREATE_PLAN_TABS.promotions);
  registerErrorField(registerRecurringAmount.name, CREATE_PLAN_TABS.promotions);

  return (
    <div>
      <div className="flex flex-col gap-y-6">
        <ChargeEditDrawerContentItemOptional
          fieldPath={registerDescription.name}
          label="Add description"
        >
          <VayuTextField
            {...registerDescription}
            fullWidth
            focused
            placeholder="Add a description"
            multiline
            error={isNotNullOrUndefined(get(errors, registerDescription.name))}
          />
        </ChargeEditDrawerContentItemOptional>

        <ChargeEditDrawerContentItemOptional
          fieldPath={registerRecurringAmount.name}
          label="Recurring Discount"
          handleOnChecked={checked => {
            checked
              ? setValue(registerRecurringAmount.name, -1)
              : setValue(registerRecurringAmount.name, undefined);
          }}
        >
          <Controller
            control={control}
            name={registerRecurringAmount.name}
            render={({ field }) => (
              <PlanDurationSelect
                value={field.value}
                onChange={(event, newValue) => {
                  event.preventDefault();
                  field.onChange(newValue);
                }}
              />
            )}
          />
        </ChargeEditDrawerContentItemOptional>
      </div>
    </div>
  );
};